<template>
    <div class="jump-warphd nav-bar-fixed">
        <van-nav-bar title="Erp信息" left-arrow fixed
                     @click-left="back"/>
        <van-collapse v-model="activeNames" class="pay-hd-item" border>
            <van-collapse-item icon="edit" title="订单信息" name="2">
                <div class="pay-hd-line">
                    <van-cell title="订单编号" :value="order.orderNumber"/>
                    <van-cell title="审核状态" :value="order.statusName"/>
                    <van-cell title="进销存出库单号" :value="order.jxcOutNo" v-if="order.jxcOutNo!=''&&order.jxcOutNo!=null"/>
                </div>
                <div class="pay-hd-line">
                    <van-cell title="生成时间" :value="order.createtime"/>
                    <van-cell title="订单总价(=货物总价+运费)" :value="order.totalPrice"/>
                    <van-cell title="发货时间" :value="order.shipTime"/>
                    <van-cell title="期望到货时间" :value="order.expected_arrival_time"/>
                    <van-cell title="货物总价" :value="order.goodsAmount"/>
                    <van-cell title="成交价格" :value="order.transactionPrice"/>
                </div>
                <van-cell title="运费" :value="order.freightPrice"/>
                <van-cell title="配送方式" :value="order.deliveryMode"/>
            </van-collapse-item>
        </van-collapse>
        <van-collapse v-model="activeNames" class="pay-hd-item">
            <van-collapse-item icon="info-o" title="会员信息" name="3">
                <van-cell title="真实姓名" :value="user.trueName"/>
                <van-cell title="用户名 " :value="user.userName"/>
                <van-cell title="用户类型 " :value="user.user_type_name"/>
                <van-cell title="手机号 " :value="user.mobile"/>
                <van-cell title="所属分公司 " :value="user.org_name"/>
                <van-cell title="所属片区 " :value="user.org_area"/>
                <van-cell title="所在地 " :value="user.org_milk_shop"/>
            </van-collapse-item>
        </van-collapse>
        <van-collapse v-model="activeNames" class="pay-hd-item">
            <van-collapse-item icon="info-o" title="订单商品" name="4">
                <div v-if="erpInfolist.length == 0">
                    还未同步到ERP
                </div>
                <div v-else class="pay-hd-line" v-for="(item, index) in erpInfolist">
                    <van-cell title="商品名称" :value="item.itemName"/>
                    <van-cell title="数量 " :value="item.orderedQuantity"/>
                    <van-cell title="价目表单价 " :value="item.unitListPrice"/>
                    <van-cell title="销售单价 " :value="item.unitSellingPrice"/>
                    <van-cell title="ERP物料单位 " :value="item.orderQuantityUomDes"/>
                    <van-cell title="ERP订单编号 " :value="item.orderNumber"/>
                    <van-cell title="ERP采购单号 " :value="item.attribute16"/>
                    <van-cell title="类型 " :value="item.orderType"/>
                    <van-cell title="状态 " :value="item.processFlagName"/>
                </div>
            </van-collapse-item>
        </van-collapse>
        <van-collapse v-model="activeNames" class="pay-hd-item">
            <van-collapse-item icon="info-o" title="发运信息" name="5">
                <div v-if="deliveryList==null||deliveryList.length == 0">
                    暂无发运信息
                </div>
                <div v-else v-for="(item, index) in deliveryList" class="pay-hd-line">
                    <van-cell title="商品名称" :value="item.itemDescription"/>
                    <van-cell title="ERP订单号 " :value="item.orderNumber"/>
                    <van-cell title="发运数量 " :value="item.shippedQuantity"/>
                    <van-cell title="状态描述 " :value="item.releasedStatus"/>
                    <van-cell title="批次号 " :value="item.lotNumber"/>
                    <van-cell title="时间 " :value="item.lastUpdateDate"/>
                </div>
            </van-collapse-item>
        </van-collapse>
    </div>
</template>
<script>
    import {
        NavBar,
        Cell,
        CellGroup,
        Field,
        Button,
        Row,
        Col,
        Collapse,
        CollapseItem,
        Tabs,
        Tab,
        Switch,
        Card,
        Tag
    } from "vant";

    export default {
        name: "ApprovalDetail",
        components: {
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
            [Switch.name]: Switch,
            [Card.name]: Card,
            [Tag.name]: Tag,
        },
        data() {
            return {
                activeNames: ["2", "3", "4", "5"],
                order: {},
                user: {},
                erpInfolist: [],
                deliveryList: []
            };
        },
        mounted() {

            let that = this;
            if (this.actionStatus == false) {
                var orderid = this.curdata.id;
                this.$api.post(that.jumuc.userCenter.selAuditedDetailInfo, {'workFlowId': orderid, 'flag': false},
                    successRes => {
                        if (successRes.success) {
                            that.orders = successRes.data.orders
                        }
                    })
            } else if (this.actionStatus == true) {
                var orderid = this.curdataAlready.id;
                this.$api.post(that.jumuc.userCenter.selAuditedDetailInfo, {'workFlowId': orderid, 'flag': false},
                    successRes => {
                        if (successRes.success) {
                            that.orders = successRes.data.orders
                        }
                    })
            }
            let json = {}
            if (that.$route.query.type != null) {
                json['erpInfoId'] = that.$route.query.id
                json['orderType'] = that.$route.query.type
            } else {
                json['erpInfoId'] = that.$route.query.id
                json['deliveryOrderId'] = that.$route.query.deliveryOrderId
            }
            this.$api.post(that.jumuc.stock.erp_orderinfo_view, json,
                successRes => {
                    if (successRes.success) {
                        that.order = successRes.data.order;
                        if(that.order.status==0){
                             that.order.statusName='待'+that.order.role_deal_name+'审核'
                        }else if(that.order.status==1){
                             that.order.statusName='已通过'
                        }else if(that.order.status==2){
                                 that.order.statusName='已驳回'
                        }
                        that.user = successRes.data.user
                        that.erpInfolist = successRes.data.erpInfolist;
                        that.deliveryList = successRes.data.deliveryList
                    }
                })
        },
        methods: {
            back() {
                history.back();
            },
            showOpen1(i) {
                this.isOpen1 = !this.isOpen1;
                this.openText1 = this.isOpen1 ? '收起' : '展开';
                this.openIcon1 = this.isOpen1 ? 'arrow-up' : 'arrow-down';
            }
        },
    };
</script>
<style  scoped>
    @bule-thame: #3C6EEB;
  
    body {
        background: #f7f7ff;
    }
 .van-collapse-item__content{
       padding:15px;
   }

    #app .van-tabs__line {
        height: 45px;
        background-color: rgba(255, 255, 255, 0.1);
        min-width: 80px;
        left: -10px;
    }

    .appr-tabs {
        .van-tab {
            color: #fff;
        }
        .van-tabs__nav {
            background-color: @bule-thame;
        }
        .van-hairline--top-bottom::after {
            border-width: 0;
        }
    }

    .jump-warphd {

        .van-icon {
            color: @bule-thame;
        }
        .van-cell {
            padding: 0;
        }
        .van-collapse-item__title {
            padding: 10px 15px;
            border:1px solid red
        }
        .appr-item {
            padding: 10px;
            margin-bottom: 10px;
            background-color: #fff;
            h5 {
                font-size: 16px;
                padding-bottom: 10px;
                i {
                    padding: 5px;
                    background-color: @bule-thame;
                    color: #fff;
                    border-radius: 100%;
                    margin-right: 5px;
                }
            }
            p {
                padding: 4px 0;
                font-size: 14px;
                &.item-r {
                    color: #ccc;
                    text-align: right;
                }
                span {
                    min-width: 60px;
                    display: inline-block;
                    margin-right: 5px;
                }
            }
            &-head {
                border-bottom: 1px #f7f7f7 solid;
                &-hd {
                    position: relative;
                }
            }
            &-foot {
                border-top: 1px #f7f7f7 solid;
                p {
                    color: #ccc
                }
            }
            .item-arrow {
                border-top: 1px solid #f7f7f7;
                text-align: center;
                color: @bule-thame;
            }
            .line {
                display: block;
                border-bottom: 1px solid #f7f7f7;
            }
        }
        .pro-body {
            padding: 10px;
            .pro-item {
                margin-bottom: 10px;
                background-color: #fff;
                padding: 10px;
                h5 {
                    font-size: 14px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #f7f7f7;
                }
                span {
                    min-width: 60px;
                    display: inline-block;
                    margin-right: 5px;
                }
                p {
                    font-size: 14px;
                    padding: 10px 0;
                }
                &-by {
                    padding: 10px 0 0;
                }
                &-ft {
                    background-color: #f7f7f7;
                    padding: 10px;
                }
                .pro-edit {
                    color: @bule-thame;
                    text-decoration: underline;
                    i {
                        vertical-align: -2px;
                    }
                }
            }
        }
        .pay-by {
            padding: 10px;
            .pay-item {
                background-color: #fff;
                padding: 10px;
                position: relative;
                margin-bottom: 10px;
                p {
                    color: #ccc;
                    font-size: 12px;
                    padding: 5px 0;
                }
                &-ft {
                    padding-top: 10px;
                    p {
                        color: #333;
                    }
                }
                .pay-state {
                    text-align: right;
                    color: @bule-thame;
                    i {
                        display: inline-block;
                        padding: 5px;
                        border-radius: 100%;
                        background-color: @bule-thame;
                    }
                }
                &-rd {
                    position: absolute;
                    top: 0;
                    left: -5px;
                    width: 10px;
                    height: 100%;
                    background-color: @bule-thame;
                    border-radius: 10px 0 0 10px;
                }

                &.ok {
                    .pay-state {
                        color: #28a745;
                        i {
                            background-color: #28a745;
                        }
                    }
                    .pay-item-rd {
                        background-color: #28a745;
                    }
                }
                &.err {
                    .pay-state {
                        color: #ffc107;
                        i {
                            background-color: #ffc107;
                        }
                    }
                    .pay-item-rd {
                        background-color: #ffc107;
                    }
                }
            }
        }
        .pay-hd-item {
            margin-bottom: 10px;
            .pay-hd-line {
                border-bottom: 1px solid #f7f7f7;
                margin-bottom: 10px;
            }
            .van-field {
                border: 1px solid #f7f7f7;
            }
        }
        .van-card__title {
            font-size: 0.9rem;
            margin-bottom: 10px;
        }
        .cardTitle {
            width: 50%;
            font-size: 0.8rem;
            line-height: 1.6rem;
            display: inline-block;
        }
        .cardData {
            width: 50%;
            font-size: 0.8rem;
            line-height: 1.6rem;
            display: inline-block;
            text-align: right;
        }

        .van-cell:not(:last-child)::after {
            border: none;
        }

        .apply {
            .van-field {
                margin: 10px 0;
                border: 1px solid #f7f7f7;
            }
            .van-col--8 {
                padding: 0 10px;
            }
            button {
                font-size: 14px;
                height: 40px;
                line-height: 38px;
                background-color: @bule-thame;
                border-color: @bule-thame;
            }
            button.danger {
                background-color: #ffc107;
                border-color: #ffc107;
            }
        }

        .item-body-warp {
            height: 60px;
            overflow: hidden;
            position: relative;
        }
        .item-body-warp.open {
            height: auto;
        }
    }
</style>